export const BACKEND_NAME = 'github';
export const BACKEND_LABEL = 'GitHub';

export const DEFAULT_API_ROOT = 'https://api.github.com';
export const DEFAULT_AUTH_ROOT = 'https://api.netlify.com';
export const DEFAULT_AUTH_PATH = 'auth';
export const DEFAULT_PKCE_AUTH_ROOT = 'https://github.com';
export const DEFAULT_PKCE_AUTH_PATH = 'login/oauth/authorize';
